import { NavigationEnd, NavigationStart } from '@angular/router'
import { Dictionary } from '@ngrx/entity'
import { createFeatureSelector, createSelector, MemoizedSelector } from '@ngrx/store'
import { NavStateContainerBase } from '../../modules/navigation-state'
import { DtoType, pageStateAdapter, pageStateFeatureKey, PageStateState } from './page-state.state'

export const selectPageStateState = createFeatureSelector<PageStateState>(pageStateFeatureKey)

const { selectIds, selectEntities, selectAll, selectTotal } = pageStateAdapter.getSelectors()

export const selectPageStateIds = createSelector(selectPageStateState, selectIds)

export const selectPageEntities = createSelector(selectPageStateState, selectEntities)

export const selectAllPageStates = createSelector(selectPageStateState, selectAll)

export const selectPageStateCount = createSelector(selectPageStateState, selectTotal)

/** Checks if a state for a given token exists */
export const selectTokenExists = createSelector(selectPageStateIds, (ids: string[], props: any) =>
  ids.some((id) => id === props.token)
)

/** Loads a state for a given token */
export const selectStateForToken = createSelector(
  selectPageEntities,
  (entities: Dictionary<NavStateContainerBase>, props: any) => entities[props.token]
)

export const selectStateForToken2 = (token: string) => createSelector(selectEntities, (entities) => entities[token])

// test
export const selectAnyPageStateIsStored = createSelector(selectPageStateState, selectEntities)

export const selectStateForNavId = createSelector(
  selectAllPageStates,
  (entities: NavStateContainerBase[], props: any) => entities.find((entity) => entity.navId === props.id)
)
export const selectStateForNavIdExists = createSelector(
  selectAllPageStates,
  (entities: NavStateContainerBase[], props: any) => entities.some((entity) => entity.navId === props.id)
)

const getLastNavEventPair = (state: PageStateState) => ({ navStart: state.lastNavStart, navEnd: state.lastNavEnd })

export const selectLastNavEventPair: MemoizedSelector<object, { navStart: NavigationStart; navEnd: NavigationEnd }> =
  createSelector(selectPageStateState, getLastNavEventPair)

const getSelectCurrentEntity = (state: PageStateState) => ({
  currentEntity: state.currentEntity
  // refreshTrigger: state.entityDetailParams.refreshTrigger
})

export const selectCurrentEntity: MemoizedSelector<object, { currentEntity: any[] }> = createSelector(
  selectPageStateState,
  getSelectCurrentEntity
)

const getSelectCurrentDtoType = (state: PageStateState) =>
  !!state && !!state.currentDtoType
    ? {
        config: state.currentDtoType.config,
        headerFields: state.currentDtoType.headerFields,
        editableFields: state.currentDtoType.editableFields,
        creationFields: state.currentDtoType.creationFields,
        excludedPanels: state.currentDtoType.excludedPanels
        // refreshTrigger: state.entityDetailParams.refreshTrigger
      }
    : ({} as DtoType)

export const selectCurrentDtoType: MemoizedSelector<object, DtoType> = createSelector(
  selectPageStateState,
  getSelectCurrentDtoType
)
